export const calculateThreshold = (height: number): number => {
  if (!Number(height)) return 0;

  const threshold = Math.floor(((height * 0.5) / 948) * 100) / 100;

  if (threshold < 0) return 0;

  return Math.min(threshold, 1);
};
